module.exports = __webpack_public_path__ + "static/media/MRI2-removebg-preview.f30b20db.png";